import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { PageValue } from "./page";
import useUtilitySources from "../utils/useutilitysources";
import { AppValue } from "./app";
import { createContext, useReducer, useEffect, useContext } from "react";
import sources from "../utils/sources";
export const SourcesValue = createContext(null);
export const SourcesDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  }
};

const getStateType = (typeRef, block) => {
  if (!typeRef) {
    return null;
  }
  const path = typeRef.split(".");
  let value = { ...block.props };
  let usePropValue = false;
  path.forEach((p) => {
    if (value[p]) {
      value = value[p];
      usePropValue = true;
    } else {
      usePropValue = false;
    }
  });
  if (usePropValue) {
    return value;
  } else {
    return null;
  }
};

export default function SourcesContext({ children }) {
  const [state, dispatch] = useReducer(reducer, []);
  const tree = useContext(PageValue);
  const { currentPage } = useContext(AppValue);
  const utilitySources = useUtilitySources();

  useEffect(() => {
    if (tree) {
      const _sources = [];

      const getSources = (block) => {
        if (block.customProps) {
          Object.keys(block.customProps).forEach((key) => {
            const _s = {
              name: block.customProps[key].name,
              code: `props.${key}`,
              returnType: block.customProps[key].type,
              returnList: block.customProps[key].list,
              category: "Prop",
              params: [],
            };
            _sources.push(_s);
          });
        }
        if (block.stateVariables) {
          if (block.component === "Page" || block.component === "Component") {
            _sources.push({
              name: `${block.name}'s`,
              code: "_pageState",
              params: [],
              returnType: block.id,
              returnList: false,
              async: false,
              category: "Page",
            });
          } else {
            const fields = block.stateVariables.map((x) => {
              return {
                returnType: x.typeRef ? getStateType(x.typeRef, block) : x.type,
                returnList: x.list === true,
                name: x.displayName,
                code: x.value,
                displayName: x.displayName,
                params: x.props || [],
                category: "Values",
              };
            });
            _sources.push({
              name: `${block.name}'s`,
              code: block.id,
              fields: fields,
              params: [],
              returnType: null,
              returnList: false,
              async: false,
              category: "Inputs",
            });
          }
        }
        if (block.children.length > 0) {
          block.children.forEach((b) => {
            getSources(b);
          });
        }
      };

      getSources(tree);

      const dynamicPageSource = [];

      if (currentPage && currentPage.dynamic) {
        dynamicPageSource.push({
          name: `This page's ${currentPage.dynamic.type}`,
          code: `props.data`,
          params: [],
          returnType: currentPage.dynamic.type,
          returnList: false,
          async: false,
          category: "Page",
        });
      }

      dispatch({
        type: "set",
        value: [
          ...dynamicPageSource,
          ...utilitySources,
          ...sources,
          ..._sources,
        ],
      });
    }
  }, [tree, utilitySources]);

  return (
    <SourcesValue.Provider value={state}>
      <SourcesDisbatch.Provider value={dispatch}>
        {children}
      </SourcesDisbatch.Provider>
    </SourcesValue.Provider>
  );
}
